// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  //urlproducts: 'http://localhost:5000/uploads/products',
  urlproducts: 'http://tgsmanagement.net/',
  //urlapi: 'http://localhost:8000/api/',
  //urlapi: 'http://localhost:8000/api/',
  urlapi: 'https://grocery.appstgs.com:9000/api/',
  //urlapi: 'http://tgsmanagement.net:9000/api/'
  //urlapi: 'http://grocery.appstgs.com:5000/api/',
  //urlapi: 'http://grocery.appstgs.com:5000/api/',
  publicBucketKey: 'DO006UPQLEMEZ9YM9EVB',
  secretBucketKey: 'aXdUo6zqE93tBdCQafKthYdmLmxMGn5rbbkX5yXq4AM',
  baseUrlBucket: 'https://old-cms-stores.nyc3.cdn.digitaloceanspaces.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
